<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información del grupo</h1>
    <div class="information" v-if="group">
      <p v-if="group.name" class="information__text"><strong class="information__text--strong">Nombre del grupo: </strong>{{group.name}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery_groups/view.vue